export type BreakpointSize = 'mobile' | 'tablet' | 'laptop' | 'desktop' | '2xl'

export const getWindowWidth = (): BreakpointSize =>
  (import.meta.client
    ? window
        .getComputedStyle(document.body, ':after')
        .getPropertyValue('content')
        .replace(/"/g, '')
    : '') as BreakpointSize
